export default __webpack_public_path__ + "static/media/94902d4390fa8165.9bbf4ceb0ee45f725ee42c85231b6b85.svg";